import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay before showing banner
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    try {
      localStorage.setItem("cookieConsent", JSON.stringify({
        necessary: true,
        analytics: true,
        marketing: true,
        timestamp: new Date().toISOString()
      }));
      // Enable Google Analytics if accepted
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'analytics_storage': 'granted'
        });
      }
    } catch (e) {
      console.log("Could not save cookie consent");
    }
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    try {
      localStorage.setItem("cookieConsent", JSON.stringify({
        necessary: true,
        analytics: false,
        marketing: false,
        timestamp: new Date().toISOString()
      }));
    } catch (e) {
      console.log("Could not save cookie consent");
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-stone-200 shadow-2xl p-4 sm:p-6"
      data-testid="cookie-consent"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex-1 pr-4">
            <h3 className="text-lg font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Cookie beállítások
            </h3>
            <p className="text-sm text-slate-600">
              Weboldalunk sütiket használ a felhasználói élmény javítása és a forgalom elemzése érdekében. 
              Az "Összes elfogadása" gombra kattintva hozzájárul az analitikai sütik használatához is, 
              amelyek segítenek nekünk a weboldal fejlesztésében.{" "}
              <Link to="/adatkezelesi-tajekoztato" className="text-amber-600 hover:text-amber-700 underline">Adatkezelési tájékoztató</Link>
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
            <Button
              onClick={acceptNecessary}
              variant="outline"
              className="rounded-none px-6 py-3 border-slate-300 text-slate-700 hover:bg-slate-50 text-sm"
            >
              Csak szükségesek
            </Button>
            <Button
              onClick={acceptAll}
              className="rounded-none px-6 py-3 bg-amber-600 text-white hover:bg-amber-700 text-sm"
            >
              Összes elfogadása
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
